import React from "react";
import { ModeRendererProps } from "./types";

export function AgamPrismMode({ brand }: ModeRendererProps) {
  return (
    <g transform="translate(397 540)">
      {Array.from({ length: 28 }).map((_, i) => (
        <g key={i} transform={`rotate(${i * 12})`}>
          <rect x="0" y={-6 - (i % 3 ? 1 : 0)} width="310" height="12" fill="url(#spectrum)" opacity="0.9" />
        </g>
      ))}
      {Array.from({ length: 9 }).map((_, i) => (
        <circle key={i} r={60 + i * 26} fill="none" stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber} strokeOpacity="0.5" />
      ))}
      <circle r="310" fill="none" stroke={brand.white} strokeWidth="2" />
    </g>
  );
}
